import { render, staticRenderFns } from "./FormMixin.vue?vue&type=template&id=b72ce53a&scoped=true&"
import script from "./FormMixin.vue?vue&type=script&lang=js&"
export * from "./FormMixin.vue?vue&type=script&lang=js&"
import style0 from "./FormMixin.vue?vue&type=style&index=0&id=b72ce53a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72ce53a",
  null
  
)

export default component.exports